import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { NgSelectModule } from "@ng-select/ng-select";
import {
  UniAccordionModule,
  UniButtonsModule,
  UniFileInputModule,
  UniFormFieldModule,
  UniHeadingModule,
  UniInputModule,
  UniSelectModule,
  UniStepperModule,
  UniSummaryModule,
  UniAlertModule,
  UniIconsModule,
  UniTableModule,
} from "@universal-ui";
import { NgxFileDropModule } from "ngx-file-drop";

import { SharedModule } from "@shared/Modules/shared.module";

import { ConfirmationComponent } from "./Components/Confirmation/confirmation.component";
import { CustomerFormComponent } from "./Components/CustomerForm/customer-form.component";
import { DocumentsPreviewModalComponent } from "./Components/Documents/documents-preview-modal/documents-preview-modal.component";
import { DocumentsComponent } from "./Components/Documents/documents.component";
import { UploadMultipleDocumentsModalComponent } from "./Components/Documents/upload-multiple-documents-modal/upload-multiple-documents-modal.component";
import { RequestDataFormComponent } from "./Components/RequestDataForm/request-data-form.component";
import { SideSummaryComponent } from "./Components/SideSummary/side-summary.component";
import { RequestCreationRoutingModule } from "./request-creation-routing.module";
import { RequestCreationComponent } from "./request-creation.component";
import { RequestCreationFormService } from "./Services/request-creation-form.service";
import { UploadMultipleFilesService } from "./Services/upload-multiple-files.service";

@NgModule({
  declarations: [
    RequestCreationComponent,
    CustomerFormComponent,
    RequestDataFormComponent,
    DocumentsComponent,
    ConfirmationComponent,
    SideSummaryComponent,
    DocumentsPreviewModalComponent,
    UploadMultipleDocumentsModalComponent,
  ],
  imports: [
    CommonModule,
    RequestCreationRoutingModule,
    SharedModule,
    UniFormFieldModule,
    UniInputModule,
    UniStepperModule,
    UniButtonsModule,
    UniFileInputModule,
    NgSelectModule,
    ReactiveFormsModule,
    UniSummaryModule,
    UniAccordionModule,
    UniSelectModule,
    UniHeadingModule,
    UniAlertModule,
    UniIconsModule,
    UniTableModule,
    NgxFileDropModule,
  ],
  providers: [RequestCreationFormService, UploadMultipleFilesService],
})
export class RequestCreationModule {}
